import { render, staticRenderFns } from "./RepasseFornecedorSinteticoRead.vue?vue&type=template&id=4976d93a&"
import script from "./RepasseFornecedorSinteticoRead.vue?vue&type=script&lang=js&"
export * from "./RepasseFornecedorSinteticoRead.vue?vue&type=script&lang=js&"
import style0 from "./RepasseFornecedorSinteticoRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports